import React, {useEffect} from 'react'
import { Col, Row } from 'react-bootstrap'

import {checkIdExistsStatus} from '../../utils/check-id-exists'
import CheckBox from '../input/checkbox'


const StatusFilter =({status, UpArrow, config, statusList, setShowStatus, handleStatusChange, search})=>{
    useEffect(() => {
      
    }, [statusList])
    return <Col lg={12} className="mb-2">
    <Row className={status ? "align-items-center mb-2" : "align-items-center"}>
      <Col xs={10} className="mb-2">
        <h5>Status</h5>
      </Col>
      <Col xs={2} className="text-right mb-2">
        <button
          className="no-outline no-border no-background p-0"
          onClick={() => setShowStatus(!status)}
        >
          <img
            src={UpArrow}
            alt="wdn-arrow"
            className={!status ? "up" : "down"}
          />
        </button>
      </Col>
      {status &&
        config.status &&
        config.status.map(stat =>
          stat.status === "Unavailable" ? (
            ""
          ) : (
            <Col key={stat.id} lg={12}>
              <CheckBox
                label={stat.status}
                value={stat.id}
                onChange={handleStatusChange}
                filters={true}
                checked={
                    checkIdExistsStatus(
                  statusList,
                  stat.id.toString()
                )}
              />
            </Col>
          )
        )}
    </Row>
    <div className="border-bottom mb-2"></div>
  </Col>
}

export default StatusFilter